/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFollowsByActor.defs.js'
export { main as default } from './getSuggestedFollowsByActor.defs.js'
